module.exports = __webpack_public_path__ + "img/value_en.fd7fa98a.svg";